import { render, staticRenderFns } from "./DbChip.vue?vue&type=template&id=b31bf3ea&scoped=true&"
import script from "./DbChip.vue?vue&type=script&lang=ts&"
export * from "./DbChip.vue?vue&type=script&lang=ts&"
import style0 from "./DbChip.vue?vue&type=style&index=0&id=b31bf3ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31bf3ea",
  null
  
)

export default component.exports